import {useState, useRef, useEffect} from "react";
import {Alert, Button, Group, Paper, SimpleGrid, Stack, Text, TextInput, ThemeIcon, Title} from "@mantine/core";
import {Github, Globe, Link2, Code, AlertTriangle} from "lucide-react";
import {useTranslation} from "react-i18next";

const NetworkConfiguration = ({phase, editable = true}) => {

  const [config, setConfig] = useState({
    appUrl: document.location.origin,
    githubUrl: 'https://github.com',
    appName: 'Timestamp GIT',
    githubOrgSlug: '',
    });

  const [saveStatus, setSaveStatus] = useState('idle');

  const [prepareRsp, setPrepareRsp] = useState(null);

  const {t} = useTranslation();

  const formRef = useRef(null);

  const handleSave = async () => {
      setSaveStatus('saving');

      const url = new URL("/api/prepareSetup", document.location.origin);
      url.search = new URLSearchParams(config).toString();


      const req = await fetch(url);

      if (req.ok) {
          const rsp = await req.json();
          setPrepareRsp(rsp);

          window.setTimeout(() => {
              formRef.current.submit();
                }, 2000);

          console.log(rsp);
            }

        setSaveStatus("success");
        };

      useEffect(() => {

          var valid = true;

          const phase2 = async () => {
              const url = new URL("/api/prepareSetup2", document.location.origin);
              const req = await fetch(url);
              const rsp = await req.json();

              if (valid) {
                  setPrepareRsp(rsp);

                  window.setTimeout(() => {
                      formRef.current.submit();
                  }, 2000);
              }
            }

          if (phase === "setup2") {
              phase2();
              }

          return () => {
                valid = false;
                }

          }, [phase])


    // During mid-setup phases (step1-step3) the network settings are already
    // stored in the configuration. The form must not be editable then, but the
    // phase-2 auto-submit below still needs to run.
    if (!editable) {
        return (
            <Paper radius="lg" p="lg" mb="lg" withBorder hidden>
                <form action={prepareRsp?.setupUrl} method={"POST"} ref={formRef}>
                    <input type="hidden" name="manifest" id="manifest" value={JSON.stringify(prepareRsp?.manifest)}/>
                </form>
            </Paper>
        );
    }

    return <Paper radius="lg" p="lg" mb="lg" withBorder>
                <Stack gap="lg">
                    <Group gap="sm" align="center">
                        <ThemeIcon variant="light" color="blue" radius="xl" size="md">
                            <Globe size={16} />
                        </ThemeIcon>
                        <Title order={2} fz="1rem" fw={700}>
                            {t('Instance Network Settings')}
                        </Title>
                    </Group>

                    <Alert variant="light" color="red" radius="md" title={t("Warning: Recreating the GitHub App")} icon={<AlertTriangle size={16} />}>
                        <Text size="sm">
                            {t('Recreating the GitHub App will invalidate all existing app installations. All users who previously installed the app will need to re-install it, and all timestamp data linked to the old app will be orphaned. Only proceed if you are absolutely certain.')}
                        </Text>
                    </Alert>

                    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg" verticalSpacing="lg">
                    <TextInput
                        label={t("App Name")}
                        description={t('Name of the application as displayed in the UI')}
                        leftSection={<Code size={16}/>}
                        value={config.appName}
                        onChange={(e) => setConfig({...config, appName: e.target.value})}
                    />
                    <TextInput
                        label={t('Public Base URL')}
                        description={t('Required for GitHub Webhook callbacks.')}
                        leftSection={<Link2 size={16}/>}
                        value={config.appUrl}
                        onChange={(e) => setConfig({...config, appUrl: e.target.value})}
                    />
                    <TextInput
                        label={t('Local GitHub URL')}
                        description={t('Internal GitHub Enterprise API endpoint.')}
                        leftSection={<Github size={16}/>}
                        value={config.githubUrl}
                        onChange={(e) => setConfig({...config, githubUrl: e.target.value})}
                    />
                    <TextInput
                        label={t('GitHub Organization Slug')}
                        description={t('Optional. Your GitHub organization slug for the app installation.')}
                        leftSection={<Github size={16}/>}
                        value={config.githubOrgSlug}
                        onChange={(e) => setConfig({...config, githubOrgSlug: e.target.value})}
                    />
                    </SimpleGrid>

                    <Group justify="flex-end">
                        <Button
                            variant="filled"
                            color={saveStatus === 'success' ? 'teal' : 'blue'}
                            disabled={saveStatus === 'saving'}
                            onClick={handleSave}
                            size="md"
                        >
                            {t("Store")}
                        </Button>
                    </Group>

                    <form action={prepareRsp?.setupUrl} method={"POST"} ref={formRef}>
                        <input type="hidden" name="manifest" id="manifest" value={JSON.stringify(prepareRsp?.manifest)}/>
                    </form>
                </Stack>
            </Paper>;
        }

export default NetworkConfiguration;
